import React, { useRef, useState } from "react";
import { toast } from "sonner";
import { IoCloudUploadOutline, IoLinkOutline, IoClose } from "react-icons/io5";

/**
 * ImageUpload — champ d'image réutilisable : upload direct (base64) OU coller une URL.
 * value = string (URL http ou data:image base64). onChange(value).
 */
export default function ImageUpload({ value, onChange, label = "Image", testid = "image", maxMb = 3 }) {
  const fileRef = useRef(null);
  const [mode, setMode] = useState("upload");
  const pick = (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    if (f.size > maxMb * 1024 * 1024) { toast.error(`Image trop lourde (max ${maxMb} Mo).`); return; }
    const reader = new FileReader();
    reader.onload = () => onChange(reader.result);
    reader.readAsDataURL(f);
  };
  return (
    <div style={s.wrap}>
      {label && <span style={s.label}>{label}</span>}
      <div style={s.row}>
        <div style={{ ...s.preview, backgroundImage: value ? `url(${value})` : "none" }} data-testid={`${testid}-preview`}>
          {!value && <span style={s.previewEmpty}>Aucune image</span>}
          {value && <button type="button" style={s.clear} data-testid={`${testid}-clear`} onClick={() => onChange("")}><IoClose size={14} /></button>}
        </div>
        <div style={{ flex: 1 }}>
          <div style={s.tabs}>
            <button type="button" style={{ ...s.tab, ...(mode === "upload" ? s.tabOn : {}) }} onClick={() => setMode("upload")}><IoCloudUploadOutline size={14} /> Uploader</button>
            <button type="button" style={{ ...s.tab, ...(mode === "url" ? s.tabOn : {}) }} onClick={() => setMode("url")}><IoLinkOutline size={14} /> URL</button>
          </div>
          {mode === "upload" ? (
            <>
              <button type="button" style={s.uploadBtn} data-testid={`${testid}-upload`} onClick={() => fileRef.current?.click()}>
                <IoCloudUploadOutline size={16} /> Choisir une image…
              </button>
              <input ref={fileRef} type="file" accept="image/*" onChange={pick} style={{ display: "none" }} data-testid={`${testid}-file`} />
            </>
          ) : (
            <input style={s.urlInput} data-testid={`${testid}-url`} value={value && value.startsWith("data:") ? "" : (value || "")} placeholder="https://…" onChange={(e) => onChange(e.target.value)} />
          )}
        </div>
      </div>
    </div>
  );
}

const s = {
  wrap: { display: "flex", flexDirection: "column", gap: 6 },
  label: { fontSize: 12.5, fontWeight: 700, color: "var(--text-secondary)" },
  row: { display: "flex", gap: 12, alignItems: "stretch" },
  preview: { position: "relative", width: 92, height: 68, borderRadius: 10, border: "1.5px solid var(--border-c)", background: "var(--bg-tertiary)", backgroundSize: "cover", backgroundPosition: "center", flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center" },
  previewEmpty: { fontSize: 10.5, color: "var(--text-secondary)", textAlign: "center" },
  clear: { position: "absolute", top: 4, right: 4, width: 22, height: 22, borderRadius: "50%", border: "none", background: "rgba(0,0,0,0.6)", color: "#fff", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" },
  tabs: { display: "flex", gap: 6, marginBottom: 8 },
  tab: { display: "inline-flex", alignItems: "center", gap: 5, padding: "5px 10px", borderRadius: 8, border: "1px solid var(--border-c)", background: "var(--bg-tertiary)", color: "var(--text-secondary)", fontSize: 12, fontWeight: 700, cursor: "pointer" },
  tabOn: { borderColor: "var(--brand)", color: "var(--brand)", background: "color-mix(in srgb, var(--brand) 10%, transparent)" },
  uploadBtn: { width: "100%", display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 8, padding: "10px 12px", borderRadius: 10, border: "1.5px dashed var(--border-c)", background: "var(--bg-tertiary)", color: "var(--text-primary)", fontWeight: 700, fontSize: 13, cursor: "pointer" },
  urlInput: { width: "100%", padding: "10px 12px", border: "1.5px solid var(--border-c)", borderRadius: 10, fontSize: 14, fontFamily: "inherit", color: "var(--text-primary)", background: "var(--bg-tertiary)", boxSizing: "border-box" },
};
